import React from "react"
import "./Spin.css"

const Spinner = () => <div className="Loader">Loading...</div>

export default Spinner
